import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useUiTheme } from '@/hooks/use-ui-theme';
import ClockModalOld from './clock-modal-old';
import ClockModalMissionControl from './clock-modal-mission-control';
export default function ClockModal(props) {
    const { uiTheme } = useUiTheme();
    return uiTheme === 'classic' ? (_jsx(ClockModalOld, { ...props })) : (_jsx(ClockModalMissionControl, { ...props }));
}
